const props = [
  { prop: 'provinceFrom', name: '提货省份' },
  { prop: 'cityFrom', name: '提货城市' },
  { prop: 'districtFrom', name: '提货地区', empty: true },
  { prop: 'provinceTo', name: '送达省份' },
  { prop: 'cityTo', name: '送达城市' },
  { prop: 'districtTo', name: '提货地区', empty: true },  
  { prop: 'deliverTime', name: '提货时间' },
  { prop: 'goodsMaxLen', name: '物体长度' },
  { prop: 'goodsMaxWidth', name: '物体宽度' },
  { prop: 'sbustitude', name: '是否货到付款' },
  { prop: 'billing', name: '是否需要发票' },
  { prop: 'note', name: '备注内容', empty: true },

];

export default class Order {
  constructor() {
    props.forEach(item => {
      this[item.prop] = "";
    });
    this.versionCode = '2.1.1';
  }

  validate() {
    const invalid = props.filter(item => !item.empty && this[item.prop] === '');
    return invalid;
  }
}


// WEBPACK FOOTER //
// ./src/models/Order.js